import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";


const getVehicleIndemnityCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleIndemnity}?isAll=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getVehicleIndemnityById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleIndemnity}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertVehicleIndemnity = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.VehicleIndemnity,
    input
  );
  return data;
};

const updateVehicleIndemnity = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.VehicleIndemnity,
    input
  );
  return data;
};

const deleteVehicleIndemnity = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.VehicleIndemnity}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useVehicleIndemnityCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleIndemnity],
    queryFn: () => getVehicleIndemnityCategories(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetVehicleIndemnityByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleIndemnity],
    queryFn: () => getVehicleIndemnityById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertVehicleIndemnityMutation = () => {
  return useMutation({
    mutationFn: insertVehicleIndemnity,
  });
};

export const useUpdateVehicleIndemnityMutation = () => {
  return useMutation({
    mutationFn: updateVehicleIndemnity,
  });
};

export const useDeleteVehicleIndemnityMutation = () => {
  return useMutation({
    mutationFn: deleteVehicleIndemnity,
  });
};
